import Countdown, { zeroPad } from 'react-countdown';
import { t } from 'services/translation';
import ModalActionCreator from 'action_creators/modal';
import { CheckoutError } from 'views/plugins/global_error/CheckoutError';
import styled from '@emotion/styled';
import { brandNeutralColors } from 'ui_system/compass/utils';

const TimerContainer = styled.div`
  background-color: ${brandNeutralColors.border};
  display: inline-block;
  width: 100%;
  padding: 3px 8px;
`;

const CheckoutTimerText = styled.span`
  color: ${brandNeutralColors.text.primary};
`;

interface checkoutTimerProps {
  sessionExpired: number;
  guideId: number;
  tourId: number;
  originUrl: string;
}
const CheckoutTimer = ({
  sessionExpired,
  guideId,
  tourId,
  originUrl,
}: checkoutTimerProps) => {
  const handleTimerComplete = () => {
    const title = t('TIME_LIMIT_REACHED');
    const message = t(
      'SORRY_YOUR_BOOKING_HAD_TO_BE_RELEASED_PLEASE_RESTART_YOUR_BOOKING'
    );
    const buttonUrl =
      window !== window.top ? `/i/${guideId}/c/tours/${tourId}` : originUrl;

    ModalActionCreator.show({
      content: (
        <CheckoutError title={title} message={message} buttonUrl={buttonUrl} />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: false },
      showIcon: false,
    });
  };
  return (
    <TimerContainer>
      <Countdown
        date={sessionExpired}
        onComplete={handleTimerComplete}
        renderer={({ minutes, seconds }) => (
          <CheckoutTimerText
            data-testid="timer-content"
            className="checkout-timer-text"
          >
            {t('WE_ARE_HOLDING_YOUR_BOOKING_FOR')}{' '}
            <strong>
              {zeroPad(minutes)}:{zeroPad(seconds)}
            </strong>{' '}
            {t('MINUTES')}.
          </CheckoutTimerText>
        )}
      />
    </TimerContainer>
  );
};
export default CheckoutTimer;
